module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('ui-title-red', {
    attrs: {
      "textTitle": "Presupuesto mensual: Ingresos por salario"
    }
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": 'Presupuesto mensual: Ingresos por salario',
      "videoEmbed": "ADMINISTRACIONDINERO24IngresosXSalario (55).mp4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-4": ""
    }
  }, [_c('p', [_vm._v("\n        Lo primero que determinará serán sus ingresos por concepto de salario mensual. "), _c('br'), _vm._v(" Debe completar el siguiente cuadro con sus ingresos únicamente en los campos donde aplique. "), _c('br'), _vm._v(" Encontrará cuatro columnas: "), _c('br')]), _vm._v(" "), _c('ui-list', {
    attrs: {
      "bullet": "bullet-dav",
      "lista": _vm.lista
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n        Importante: no incluya puntos ni comas.\n      ")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('ui-calculadora', {
    attrs: {
      "formulario": _vm.ingresoSalario,
      "nombresCols": _vm.nombres,
      "resultadoDiferencia": _vm.resultadoDiferencia,
      "resultadoTotal": _vm.resultadoTotal
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5752a7dd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-24.vue
// module id = 995
// module chunks = 1